module.exports = __webpack_public_path__ + "static/media/AndroidTv.08481eea.png";